import { render, staticRenderFns } from "./InputCPF.vue?vue&type=template&id=05b5e477&scoped=true"
import script from "./InputCPF.vue?vue&type=script&lang=js"
export * from "./InputCPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5e477",
  null
  
)

export default component.exports